import RrStarRatings from './code/Scripts/Components/rr-star-ratings.vue';

export default {
  components: {
    RrStarRatings,
  },
};
